export function isExplicitE2ETestMode(
  mode = import.meta.env.MODE,
  e2eAuthMock = import.meta.env.VITE_E2E_AUTH_MOCK
): boolean {
  return mode !== 'production' &&
    e2eAuthMock === 'true' &&
    typeof window !== 'undefined' &&
    window.E2E_TEST_MODE === true;
}
